import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent'
import ReactGA from 'react-ga4'

export default function CorpStageCookieConsent({ onAccept }) {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept all cookies"
      declineButtonText="Reject non-essential"
      enableDeclineButton
      onAccept={() => {
        // Guard the GA id and swallow any init error. If this handler throws,
        // react-cookie-consent never hides the banner (setState runs after
        // onAccept), so the Accept button would appear broken.
        const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID
        if (gaId && gaId !== 'G-XXXXXXXXXX') {
          try { ReactGA.initialize(gaId) } catch (e) { console.warn('GA init failed', e) }
        }
        if (onAccept) onAccept()
      }}
      onDecline={() => {
        // GA4 does not initialise on decline
        console.log('Analytics cookies declined')
      }}
      style={{
        background: '#1A3D2B',
        borderTop: '1px solid rgba(82,183,136,0.2)',
        padding: '1.25rem 2rem',
        alignItems: 'center',
        fontSize: '0.875rem',
        fontFamily: "'Inter', system-ui, sans-serif",
        zIndex: 9999,
      }}
      contentStyle={{
        margin: '0',
        flex: '1',
        color: 'rgba(255,255,255,0.85)',
        lineHeight: '1.6',
      }}
      buttonStyle={{
        background: '#0E7C7B',
        color: '#ffffff',
        fontSize: '0.8125rem',
        fontWeight: '600',
        fontFamily: "'Inter', system-ui, sans-serif",
        borderRadius: '6px',
        padding: '0.5rem 1.25rem',
        margin: '0 0.5rem',
        border: 'none',
        cursor: 'pointer',
      }}
      declineButtonStyle={{
        background: 'transparent',
        color: 'rgba(255,255,255,0.6)',
        fontSize: '0.8125rem',
        fontWeight: '500',
        fontFamily: "'Inter', system-ui, sans-serif",
        borderRadius: '6px',
        padding: '0.5rem 1.25rem',
        margin: '0 0.5rem',
        border: '1px solid rgba(255,255,255,0.2)',
        cursor: 'pointer',
      }}
      cookieName="corpstage_cookie_consent"
      expires={365}
    >
      CorpStage uses cookies to understand how visitors use the site and to improve your experience.
      Analytics cookies are only set if you accept.{' '}
      <a
        href="/privacy"
        style={{ color: '#52B788', textDecoration: 'underline' }}
      >
        Privacy Policy
      </a>
    </CookieConsent>
  )
}

// Helper — check if consent already given (used to init GA4 on return visits)
export { getCookieConsentValue }
